import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ApplyIncentiveToTheOrderRequestBody as SchemaApplyIncentiveToTheOrderRequestBody } from '../schemas/ApplyIncentiveToTheOrderRequestBody';
import { type ApplyIncentiveToTheOrderResult as SchemaApplyIncentiveToTheOrderResult } from '../schemas/ApplyIncentiveToTheOrderResult';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const ApplyIncentiveToTheOrderContentType = 'application/json' as const;
export type ApplyIncentiveToTheOrderRequest = SchemaApplyIncentiveToTheOrderRequestBody;
export type ApplyIncentiveToTheOrderResponses = LinkCommonErrorResponses & {
    /**
     * @description Incentive applied
     */
    '200': {
        'application/json': SchemaApplyIncentiveToTheOrderResult;
    };
};
export type ApplyIncentiveToTheOrderResponseSuccess = ApplyIncentiveToTheOrderResponses['200']['application/json'];
export type ApplyIncentiveToTheOrderSearchParams = {
    signature: string;
};
export type ApplyIncentiveToTheOrderPathParameters = {
    store_slug: string;
    order_id: string;
};
export const ApplyIncentiveToTheOrderUrl = '/{store_slug}/orders/{order_id}/incentive' as const;
export const ApplyIncentiveToTheOrderMethod = 'POST' as const;
export const getApplyIncentiveToTheOrderUrl = (params: ApplyIncentiveToTheOrderPathParameters) =>
    ApplyIncentiveToTheOrderUrl.replace(/\{(\w+)\}/g, (_match, param: keyof ApplyIncentiveToTheOrderPathParameters) =>
        String(params[param])
    );
